/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types'
import useStore from '../hooks/useStore';
import { Auth, Hub } from 'aws-amplify';
import { getStoreAuth } from '../services/authService';
import Loading from '../components/Loading';
import useLoading from '../hooks/useLoading';

const MR_BASE_API = process.env.REACT_APP_MESSAGE_RUNNER_URL

const Login = ({history, isLoggedIn}) => {
  const {isLoading, setIsLoading, setIsFirstWOLoad} = useLoading()
  const [oktaAuthentication, setOktaAuthentication] = useState(false)
  const { resetStoreState } = useStore();

  useEffect(() => {
    let referer = document.referrer;
    if (!isLoggedIn && !localStorage.getItem("attemptedLogIn") && referer === `${MR_BASE_API}/home`){
      // Clean up the referrer document property so it let's you log out in instore-auth
      Object.defineProperty(document, "referrer", {get : () => "" });
      login();
    }
  },[isLoggedIn]);

  useEffect( () => {
    setIsFirstWOLoad(false)
    if (isLoggedIn){
      history.push('./home')
    }

    const determineAuthenticationMethod = async () => {
      const instoreAuthUsed = !!process.env.REACT_APP_BASE_INSTORE_API_URI;
      let storeAuth;
      if (instoreAuthUsed) {
        setIsLoading(true);
        storeAuth = await getStoreAuth();
        setIsLoading(false);
      }
      setOktaAuthentication(!storeAuth || storeAuth === "not in store")
    };

    determineAuthenticationMethod();
    
    
  },[])

  const login = async () => {
    try {
      await localStorage.setItem("attemptedLogIn", true);
      setIsLoading(true);
      const instoreAuthUsed = !!process.env.REACT_APP_BASE_INSTORE_API_URI;
      let storeAuth;
      if (instoreAuthUsed){
        storeAuth = await getStoreAuth();
      }
      if(!storeAuth || storeAuth === "not in store"){
        console.log(storeAuth, 'switching to Okta');
        Auth.federatedSignIn({ customProvider: 'Okta' });
      } else {
        Hub.dispatch('storeAuth', {event: 'signIn', data: storeAuth} )
      } 
    } catch(error){
      console.log(error)
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      {isLoading?
        (
          <Loading/>
        ):(
        <button type="button" className="login-button" onClick={login}>
          Login
        </button>
        )

      }
    </div>
  )
}

Login.propTypes = {
  history: ReactRouterPropTypes.history,
  isLoggedIn: PropTypes.bool.isRequired,
}

export default withRouter(Login)

